import { createMutation } from "../../utils/queryFactories.js";
import { z } from "zod";
import { uploadAPI } from "../../utils/uploadFetch.js";

const GetDocumentUploadResponseSchema = z.object({
  id: z.number(),
  file: z.string(),
  filename: z.string(),
  size_bytes: z.number()
});

type GetDocumentUpload = z.infer<typeof GetDocumentUploadResponseSchema>;

const GetDocumentUploadRequestSchema = z.object({
  filename: z.string(),
  file: z.instanceof(File)
});

type GetDocumentUploadRequest = z.infer<typeof GetDocumentUploadRequestSchema>;

export const useDocumentUpload = createMutation<
  GetDocumentUpload,
  GetDocumentUploadRequest,
  Error
>({
  mutationFn: async (variables) => {
    // await new Promise((resolve) => setTimeout(resolve, 10000));
    return uploadAPI<GetDocumentUploadRequest, GetDocumentUpload>({
      method: "POST",
      url: `/document/upload`,
      requestSchema: GetDocumentUploadRequestSchema,
      responseSchema: GetDocumentUploadResponseSchema,
      body: variables,
      fileKey: "file"
    });
  }
});
